import * as React from "react";
import { Create, SimpleForm, AutocompleteInput, TextInput, PasswordInput, ArrayInput, SimpleFormIterator, ReferenceArrayInput, SelectArrayInput } from 'react-admin';

export const InternalCreate = props => (
  <Create title="New External" {...props}>
    <SimpleForm>
      <TextInput source="label" required />
      <TextInput source="email" required />
      <TextInput source="phone_label_name" label="Phone label name" required />
      <PasswordInput source="password" required />
      <ReferenceArrayInput source="externals" reference="externals">
        <SelectArrayInput optionText="label" optionValue="_id" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Create>
);

// "request": {
//   "url": "http://localhost:8000/api/v1/sandbox/external_data",
//   "method": "POST",
//   "headers": { }
// }
